import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BatchDetailsService } from "@services/batch-details.service";
import { tap } from "rxjs/operators";
import { NbDialogService } from "@nebular/theme";
import {
  ChoiceDialogComponent,
  ChoiceDialogOptions,
} from "@generic/choice-dialog/choice-dialog.component";
import {
  PauseIntegrationsService,
  SimpleIntegration,
} from "@services/pause-integrations.service";
import { CourseArchivePauseIntegrationListComponent } from "./course-archive-pause-integration-list/course-archive-pause-integration-list.component";
import { NotificationsService } from "@services/notifications.service";

@Component({
  selector: "scaffold-course-archive-progress",
  templateUrl: "./course-archive-progress.component.html",
  styleUrls: ["./course-archive-progress.component.scss"],
})
export class CourseArchiveProgressComponent implements OnInit {
  @Input() showDownload = false;
  @Input() showPause = false;
  @Input() showBatchDetails = false;
  @Input() showSkipped = false;

  constructor(
    private dialog: NbDialogService,
    private batchDetailsService: BatchDetailsService,
    private router: Router,
    private pauseIntegrationService: PauseIntegrationsService,
    private notifications: NotificationsService
  ) {}
  public integrations$;
  public data$;
  public data = {
    queued: 0,
    not_found: 0,
    processing: 0,
    skipped: 0,
    failed: 0,
    complete: 0,
    total: 0,
  };
  public pauseButtonText = "Pause Archive";
  public pauseUpdates;
  public areAllPaused;
  public areAllUpdating;
  public pausedTooltipText = "loading...";
  public integrations: SimpleIntegration[] = [];
  public hasError = false;
  public isLoading = true;
  ngOnInit() {
    // have to keep reloading to align to not centralized data management in fe to ensure its up to date
    this.pauseIntegrationService.initialIntegrationLoad = true;
    this.integrations$ = this.pauseIntegrationService.getIntegrations$().pipe(
      tap(({ integrations, isLoading }) => {
        if (isLoading) return;
        const { paused, updating, resuming } = integrations.reduce(
          (acc, integration) => {
            integration.paused
              ? acc.paused.push(integration)
              : acc.resuming.push(integration);
            return acc;
          },
          { paused: [], resuming: [], updating: [] }
        );

        this.areAllPaused = integrations.length === paused.length;
        this.areAllUpdating = integrations.length === updating.length;
        this.pausedTooltipText = `
          Paused: ${paused.length}
          Resumed: ${resuming.length}
        `;
        this.pauseButtonText = this.areAllPaused
          ? "Resume Archive"
          : "Pause Archive";
        this.integrations = integrations;
      })
    );
    this.data$ = this.batchDetailsService
      .getBatchDetails$(true, this.showSkipped)
      .pipe(
        tap(({ isLoading, hasError, data }) => {
          this.isLoading = isLoading;
          this.hasError = hasError;
          this.data = data;
        })
      );
  }

  downloadCsv() {
    this.batchDetailsService.getDownloadBatchCsv();
  }

  openPauseImportsModal() {
    const options: ChoiceDialogOptions[] = [
      {
        text: `Select Integrations to ${
          this.areAllPaused ? "Resume" : "Pause"
        }`,
        action: "single",
        status: "secondary",
      },
      {
        text: `${this.areAllPaused ? "Resume" : "Pause"} Entire Archive`,
        action: "all",
        status: "primary",
      },
    ];
    const text = `Do you want to ${
      this.areAllPaused ? "resume" : "pause"
    } the entire archive or individual integrations?`;
    let settings: any = {
      context: {
        data: {
          title: this.pauseButtonText,
          text,
          options,
        },
      },
    };
    this.dialog
      .open(ChoiceDialogComponent, settings)
      .onClose.subscribe((response) => {
        if (response === "all") this.setAllIntegrationsPauseState();
        if (response === "single") this.openIntegrationListPauseModal();
      });
  }

  navigateToBatchDetails() {
    this.router.navigate(["batch-details"]);
  }

  setAllIntegrationsPauseState() {
    this.pauseIntegrationService.updateAllIntegrationsPauseState(
      !this.areAllPaused
    );
  }

  openIntegrationListPauseModal() {
    this.dialog.open(CourseArchivePauseIntegrationListComponent);
  }
}
